/* ============================================================
   Bedenimi Bul (Find My Size) — Fahhar / Stiletto teması
   Kendi kendine yeten beden önerici. Tema JS'ine bağımlı değildir;
   tetikleyici [data-fms-open], veri [data-fms-config] üzerinden gelir.
   ============================================================ */
(function () {
  "use strict";

  var overlay = null;      // lazily built
  var config = null;       // parsed from [data-fms-config]
  var state = {};
  var touched = {};
  var stepIndex = 0;
  var completed = false;
  var started = false;
  var activeBlock = null;
  var returnFocus = null;
  var previousOverflow = "";
  var measurementKeys = [];
  var steps = [];
  var labels = { bust: "Göğüs", waist: "Bel", hip: "Basen" };

  var STEPS = [
    { key: "height", label: "Boy", unit: "cm", min: 140, max: 200, def: 165, hint: "Ayakkabısız, duvara yaslanarak." },
    { key: "weight", label: "Kilo", unit: "kg", min: 40, max: 130, def: 60, hint: "Yaklaşık değer yeterli." },
    { key: "bust", label: "Göğüs", unit: "cm", min: 70, max: 120, def: 90, hint: "Bilmiyorsan tahminimizle devam et; mezuran varsa göğsün en dolgun yerinden ölç." },
    { key: "waist", label: "Bel", unit: "cm", min: 55, max: 100, def: 72, hint: "Bilmiyorsan tahminimizle devam et; ölçersen belin en ince noktası." },
    { key: "hip", label: "Basen", unit: "cm", min: 80, max: 130, def: 98, hint: "Bilmiyorsan tahminimizle devam et; ölçersen kalçanın en geniş noktası." }
  ];


  /* Product type can be blank or a legacy numeric collection ID. Never use
     the current URL collection: the same product can be opened anywhere. */
  function normalize(text) {
    return String(text || "").toLowerCase().replace(/ı/g, "i")
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ").trim();
  }

  function categoryProfile(cfg) {
    var type = normalize(cfg.productType);
    var title = normalize(cfg.productTitle);
    var bottom = /\b(pantolon|etek|sort|tayt|jogger|esofman alti)\b/;
    var whole = /\b(elbise|takim|takimi|tulum|salopet)\b/;
    var longTop = /\b(tunik|trenckot|kaban|palto|parka|ferace|kimono)\b/;
    var upper = /\b(gomlek|bluz|t shirt|tisort|sweatshirt|sweat|kazak|hirka|yelek|ceket|triko)\b/;
    var accessory = /\b(canta|cantasi|sapka|bone|bandana|bere|balaclava|atki|esarp|sal|manset|aksesuar|aksesuari|kemer|ayakkabi|terlik|cizme|bot)\b/;
    if (accessory.test(type)) return "none";
    if (/\b(bel aksesuari|canta|cantasi|sapka|bone|bandana|bere|balaclava)\b/.test(title)) return "none";
    // Garment names disambiguate combined types such as Gömlek & Bluz & Tunik.
    if (whole.test(title) || whole.test(type)) return "full";
    if (bottom.test(type)) return "bottom";
    if (longTop.test(title)) {
      if (/\b(kisa|crop)\b/.test(title) && !/\btunik\b/.test(title)) return "top";
      return "full";
    }
    if (upper.test(type) || upper.test(title)) {
      return /\b(maxi|maksi|uzun (ceket|hirka|gomlek|yelek))\b/.test(title) ? "full" : "top";
    }
    if (bottom.test(title)) return "bottom";
    if (longTop.test(type) || /\bmayo\b/.test(type + " " + title)) return "full";
    if (accessory.test(title) || /\b(pareo|fular)\b/.test(type + " " + title)) return "none";
    // Only exact category collections; campaign names must not classify a product.
    var collections = cfg.collectionHandles || [];
    if (collections.some(function (v) { return ["elbise", "takim", "salopet-tulum", "mayo", "trenckot", "kaban", "kimono"].indexOf(v) !== -1; })) return "full";
    if (collections.some(function (v) { return ["pantolon", "etek", "sort", "esofman-alti", "plaj-pantolon", "plaj-etek"].indexOf(v) !== -1; })) return "bottom";
    if (collections.some(function (v) { return ["gomlek-ve-bluz", "tisort", "sweatshirt", "kazak", "hirka", "yelek", "ceket"].indexOf(v) !== -1; })) return "top";
    return "none";
  }

  function keysForProfile(profile) {
    if (profile === "bottom") return ["waist", "hip"];
    if (profile === "top") return ["bust", "waist"];
    if (profile === "full") return ["bust", "waist", "hip"];
    return [];
  }

  function readConfig(block) {
    var el = block && block.querySelector("[data-fms-config]");
    try { return el ? JSON.parse(el.textContent) : null; } catch (err) { return null; }
  }

  function initBlocks(root) {
    root.querySelectorAll(".fms-block").forEach(function (block) {
      var cfg = readConfig(block);
      block.hidden = !cfg || categoryProfile(cfg) === "none";
    });
  }

  /* Config'ten (Liquid/JSON) gelen her metin HTML'e gömülmeden önce kaçışlanır */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ---------------- beden hesaplama ---------------- */
  function sizeTable() { return config.sizeChart; }

  function sizeForMeasurement(value, key) {
    var t = sizeTable();
    var first = t[0], last = t[t.length - 1];
    if (value < first[key][0]) return { row: first, clamped: "under" };
    for (var i = 0; i < t.length; i++) {
      if (value <= t[i][key][1]) return { row: t[i], clamped: null };
    }
    return { row: last, clamped: "over" };
  }

  function recommend() {
    var picks = {};
    var table = sizeTable();
    var winnerIndex = 0;
    var indexes = [];
    measurementKeys.forEach(function (key) {
      var pick = sizeForMeasurement(state[key], key);
      picks[key] = pick;
      var index = table.indexOf(pick.row);
      indexes.push(index);
      winnerIndex = Math.max(winnerIndex, index);
    });
    // Every relevant body measurement must fit; majority voting could choose
    // a smaller size even when a required waist/hip/bust measurement is larger.
    var outside = measurementKeys.some(function (key) { return picks[key].clamped; });
    var estimated = measurementKeys.some(function (key) { return !touched[key]; });
    var same = indexes.every(function (index) { return index === winnerIndex; });
    return {
      winnerRow: table[winnerIndex], picks: picks, estimated: estimated,
      confidence: outside ? "out" : estimated ? "estimate" : same ? "high" : "low"
    };
  }

  function estimateMeasurements(heightCm, weightKg) {
    var bmi = weightKg / Math.pow(heightCm / 100, 2);
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, Math.round(v))); }
    return {
      bust: clamp(58 + bmi * 1.55, 70, 120),
      waist: clamp(38 + bmi * 1.5, 55, 100),
      hip: clamp(62 + bmi * 1.65, 80, 130)
    };
  }

  /* ---------------- overlay iskeleti ---------------- */
  function buildOverlay() {
    overlay = document.createElement("div");
    overlay.className = "fms-overlay";
    overlay.innerHTML =
      '<div class="fms-sheet" role="dialog" aria-modal="true" aria-label="Bedenimi Bul">' +
      '  <div class="fms-header">' +
      '    <span class="fms-eyebrow" data-fms-eyebrow>BEDENİMİ BUL</span>' +
      '    <button type="button" class="fms-close" data-fms-close aria-label="Kapat">&times;</button>' +
      "  </div>" +
      '  <div class="fms-progress" data-fms-progress></div>' +
      '  <div class="fms-controls" data-fms-controls></div>' +
      "</div>";
    document.body.appendChild(overlay);


    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeQuiz();
    });
    overlay.querySelector("[data-fms-close]").addEventListener("click", closeQuiz);
  }

  /* ---------------- akış ---------------- */
  function resetState() {
    state = {}; touched = {};
    STEPS.forEach(function (s) { state[s.key] = s.def; });
    stepIndex = 0;
    completed = false;
  }

  function renderProgress() {
    var progress = overlay.querySelector("[data-fms-progress]");
    if (progress.children.length !== steps.length) {
      progress.innerHTML = steps.map(function () { return '<div class="fms-progress__dot"><i></i></div>'; }).join("");
    }
    var dots = overlay.querySelectorAll(".fms-progress__dot i");
    dots.forEach(function (dot, i) {
      dot.style.width = i < stepIndex ? "100%" : i === stepIndex ? "50%" : "0%";
    });
  }

  function sliderFill(slider) {
    var pct = (slider.value - slider.min) / (slider.max - slider.min) * 100;
    slider.style.background = "linear-gradient(to right, #211d18 " + pct + "%, #e3ddd2 " + pct + "%)";
  }

  function clearResult() {
    var w = overlay.querySelector(".fms-result");
    if (w) w.remove();
  }

  function renderStep() {
    clearResult();
    overlay.querySelector("[data-fms-progress]").style.display = "";
    overlay.querySelector("[data-fms-eyebrow]").textContent =
      "BEDENİMİ BUL · ADIM " + (stepIndex + 1) + "/" + steps.length;
    renderProgress();
    var s = steps[stepIndex];
    if ((s.key === "bust" || s.key === "waist" || s.key === "hip") && !touched[s.key]) {
      state[s.key] = estimateMeasurements(state.height, state.weight)[s.key];
    }

    var controls = overlay.querySelector("[data-fms-controls]");
    controls.innerHTML =
      '<div class="fms-ctl-row">' +
      '  <div><label id="fms-label" for="fms-slider" class="fms-ctl-title">' + s.label + '</label><div id="fms-hint" class="fms-ctl-hint">' + s.hint + "</div></div>" +
      '  <div class="fms-ctl-pill" data-fms-readout>' + state[s.key] + "<small>" + s.unit + "</small></div>" +
      "</div>" +
      '<div class="fms-slider-row">' +
      '  <button type="button" class="fms-stepper" data-fms-dec aria-label="Azalt">−</button>' +
      '  <div class="fms-slider-col">' +
      '    <input id="fms-slider" type="range" aria-describedby="fms-hint" class="fms-range" data-fms-slider min="' + s.min + '" max="' + s.max + '" step="1" value="' + state[s.key] + '">' +
      '    <div class="fms-slider-scale"><span>' + s.min + "</span><span>" + s.max + "</span></div>" +
      "  </div>" +
      '  <button type="button" class="fms-stepper" data-fms-inc aria-label="Artır">+</button>' +
      "</div>" +
      '<div class="fms-buttons">' +
      '<button type="button" class="fms-btn-back' + (stepIndex === 0 ? " is-hidden" : "") + '" data-fms-back>‹ Geri</button>' +
      '<button type="button" class="fms-btn-next" data-fms-next>' + (stepIndex === steps.length - 1 ? "Sonucu Gör" : "İleri") + "</button>" +
      "</div>" +
      (stepIndex === 0 ? '<div class="fms-privacy">Ölçülerin cihazında kalır; kaydedilmez, paylaşılmaz.</div>' : "");

    var slider = controls.querySelector("[data-fms-slider]");
    var readout = controls.querySelector("[data-fms-readout]");
    sliderFill(slider);
    slider.focus();

    function setValue(v) {
      v = Math.max(s.min, Math.min(s.max, v));
      state[s.key] = v;
      touched[s.key] = true;
      slider.value = v;
      readout.innerHTML = v + "<small>" + s.unit + "</small>";
      sliderFill(slider);
    }
    slider.addEventListener("input", function () { setValue(Number(slider.value)); });
    controls.querySelector("[data-fms-dec]").addEventListener("click", function () { setValue(state[s.key] - 1); });
    controls.querySelector("[data-fms-inc]").addEventListener("click", function () { setValue(state[s.key] + 1); });
    controls.querySelector("[data-fms-back]").addEventListener("click", function () {
      if (stepIndex > 0) { stepIndex--; renderStep(); }
    });
    controls.querySelector("[data-fms-next]").addEventListener("click", function () {
      if (stepIndex < steps.length - 1) { stepIndex++; renderStep(); }
      else { renderResult(); }
    });
  }

  function confidenceCopy(level, code) {
    var names = measurementKeys.map(function (key) { return labels[key].toLowerCase(); }).join(", ");
    if (level === "high") return { cls: "good", label: "TABLOYA GÖRE ÖNERİ", copy: "Girdiğin " + names + " ölçüleri genel beden tablomuzda aynı bedene karşılık geliyor." };
    if (level === "estimate") return { cls: "warn", label: "TAHMİNİ ÖNERİ", copy: "Boy ve kilodan tahmin edilen ölçüler kullanıldı. Daha doğru bir öneri için " + names + " çevreni mezurayla ölçüp gir." };
    if (level === "out") return { cls: "warn", label: "TABLO DIŞINDA", copy: "Kullanılan ölçülerden en az biri genel beden tablomuzun dışında. Bu ürün için güvenilir bir beden öneremiyoruz; ürün ölçülerini müşteri hizmetlerimizle kontrol edebilirsin." };
    return { cls: "warn", label: "ÖLÇÜLER FARKLI BEDENLERDE", copy: "Ölçülerin farklı bedenlere karşılık geliyor. Daha geniş olan ölçünü karşılayan " + esc(code) + " tablo bedenini esas aldık." };
  }

  function breakdownCol(key, value, code) {
    return '<div class="fms-breakdown__col"><span class="fms-breakdown__key">' + key + '</span><span class="fms-breakdown__size">' + code + '</span><span class="fms-breakdown__cm">' + value + " cm</span></div>";
  }

  /* Öneriyi üründeki gerçek beden seçeneğiyle eşle.
     Dikkat: mağaza numaraları (örn. "1 (36-38)", "2 (40-42)") tablo
     numaralarıyla AYNI DEĞİL — bu yüzden numara eşleştirmesi yapılmaz;
     önce birebir metin, sonra konfeksiyon aralığının üst sınırını karşılayan seçenek kullanılır. */
  function parseSizeRange(str) {
    var m = String(str).match(/(\d{2,3})\s*[-–\/]\s*(\d{2,3})/);
    if (m) return [Number(m[1]), Number(m[2])];
    /* tekli beden: "38" gibi tek konfeksiyon numarası da aralık sayılır */
    m = String(str).match(/(\d{2,3})/);
    if (m) {
      var n = Number(m[1]);
      if (n >= 30 && n <= 60) return [n, n];
    }
    return null;
  }

  function matchVariantValue(row) {
    var values = (config && config.sizeValues) || [];
    var i, v;
    /* Tek seçenekli ürünlerde de ölçüyle eşleşme gerekir. */
    /* 1) tablo aralığı ("36-38") değerin içinde birebir geçiyorsa */
    for (i = 0; i < values.length; i++) {
      v = String(values[i]);
      if (v.indexOf(row.label) !== -1) return v;
    }
    /* 2) harf kodu birebir eşleşiyorsa ("S", "2XL") */
    for (i = 0; i < values.length; i++) {
      v = String(values[i]);
      if (v.replace(/\s/g, "").toUpperCase() === row.code.toUpperCase()) return v;
    }
    /* 3) Genel tablodaki aralığın üst sınırını karşılayan en küçük
       ürün bedenini seç. Yalnızca sınırda kesişen daha küçük aralığı önerme.
       Örn. M (38-40) -> 40 veya 2 (40-42); XL (42-44) -> 2 (40-42) OLMAZ. */
    var rowRange = parseSizeRange(row.label);
    if (!rowRange) return null;
    var target = rowRange[1];
    var best = null, bestUpper = Infinity, bestWidth = Infinity;
    for (i = 0; i < values.length; i++) {
      v = String(values[i]);
      var r = parseSizeRange(v);
      if (!r || target < r[0] || target > r[1]) continue;
      var width = r[1] - r[0];
      if (r[1] < bestUpper || (r[1] === bestUpper && width < bestWidth)) {
        best = v; bestUpper = r[1]; bestWidth = width;
      }
    }
    return best;
  }

  function applyVariantSelection(row) {
    var value = matchVariantValue(row);
    if (!value || !config.sizeOptionPosition) return false;
    /* 1) Chip/swatch tipi seçici (fahhar'da Beden chip olarak ayarlı):
       temanın kendi tıklama mantığı ve görsel seçim çalışsın diye
       doğrudan ilgili butona gerçek click gönderilir. */
    var valSel = window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/(["\\])/g, "\\$1");
    var scope = activeBlock.closest(".shopify-section") || document;
    var chip = scope.querySelector(
      '[data-product-option="option' + config.sizeOptionPosition + '"] button[data-option-value="' + valSel + '"]'
    );
    if (chip) {
      chip.click();
      return true;
    }
    /* 2) Açılır liste tipi seçici */
    var optName = window.CSS && CSS.escape ? CSS.escape(config.sizeOptionName) : String(config.sizeOptionName).replace(/["\\]/g, "");
    var select = scope.querySelector('select[name="options[' + optName + ']"]');
    if (!select) return false;
    var found = false;
    Array.prototype.forEach.call(select.options, function (opt) {
      if (opt.value === value) found = true;
    });
    if (!found) return false;
    select.value = value;
    select.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
  }

  function renderResult() {
    completed = true;
    overlay.querySelector("[data-fms-eyebrow]").textContent = "BEDENİMİ BUL · SONUÇ";
    overlay.querySelector("[data-fms-progress]").style.display = "none";

    var r = recommend();
    var conf = confidenceCopy(r.confidence, r.winnerRow.code);
    var variantValue = r.confidence === "out" ? null : matchVariantValue(r.winnerRow);

    /* Ürün beden/stok kontrolü: öneri bu üründe yoksa veya stok dışıysa müşteriye söyle */
    var availability = (config && config.sizeAvailability) || {};
    var hasSizes = config && config.sizeValues && config.sizeValues.length > 0;
    var availNote = "";
    if (hasSizes && !variantValue && r.confidence !== "out") {
      availNote = "Bu üründe " + esc(r.winnerRow.code) + " (" + esc(r.winnerRow.label) + ") bedenine denk gelen bir seçenek maalesef yok.";
    } else if (variantValue && Object.prototype.hasOwnProperty.call(availability, variantValue) && availability[variantValue] === false) {
      availNote = esc(variantValue) + " bedeni bu üründe şu an tükendi. Bedeni yine de seçebilirsin; stok gelince haber ver seçeneği çıkarsa kullanabilirsin.";
    }

    clearResult();
    /* Büyük başlık: ürünün GERÇEK beden etiketi (mağazada harf bedeni yok —
       "M" göstermek yanıltır). Tablo harfi/aralığı küçük alt satıra iner.
       Eşleşme yoksa eskisi gibi tablo bedeni gösterilir. */
    var headline, subline;
    if (r.confidence === "out") {
      headline = "Ölçüleri kontrol et";
      subline = "GENEL TABLO SINIRLARI DIŞINDA";
    } else if (variantValue) {
      headline = esc(variantValue);
      if (hasSizes && config.sizeValues.length === 1) {
        subline = "TEK BEDEN ÜRÜN · ÖLÇÜLERİN: " + esc(r.winnerRow.code) + " (" + esc(r.winnerRow.label) + ")";
      } else {
        subline = "TABLO KARŞILIĞI: " + esc(r.winnerRow.code) + " (" + esc(r.winnerRow.label) + ")";
      }
    } else {
      headline = esc(r.winnerRow.code);
      subline = esc(r.winnerRow.num) + " · " + esc(r.winnerRow.label) + " BEDEN";
    }
    var sizeCls = "fms-size" + (headline.length > 4 ? " fms-size--long" : "");

    var wrap = document.createElement("div");
    wrap.className = "fms-result";
    wrap.innerHTML =
      '<span class="fms-badge fms-reveal fms-reveal-1 ' + conf.cls + '">' + conf.label + "</span>" +
      '<div class="' + sizeCls + ' fms-reveal fms-reveal-2">' + headline + "</div>" +
      '<div class="fms-range-label fms-reveal fms-reveal-2">' + subline + "</div>" +
      '<p class="fms-copy fms-reveal fms-reveal-3">' + conf.copy + "</p>" +
      '<p class="fms-note fms-reveal fms-reveal-3">Bu öneri genel beden tablosuna dayanır; ürünün kalıbı ve kumaş esnekliği sonucu değiştirebilir.</p>' +
      (availNote ? '<p class="fms-avail-note fms-reveal fms-reveal-3">' + availNote + "</p>" : "") +
      '<div class="fms-breakdown fms-reveal fms-reveal-4">' +
      measurementKeys.map(function (key) {
        return breakdownCol(labels[key].toLocaleUpperCase("tr-TR") + (touched[key] ? "" : " (TAHMİN)"), state[key], esc(r.picks[key].row.code));
      }).join("") +
      "</div>" +
      '<button type="button" class="fms-restart fms-reveal fms-reveal-4" data-fms-restart>Ölçüleri baştan gir</button>';
    var sheet = overlay.querySelector(".fms-sheet");
    sheet.insertBefore(wrap, overlay.querySelector("[data-fms-controls]"));

    var controls = overlay.querySelector("[data-fms-controls]");
    var ctaLabel = variantValue
      ? esc(variantValue) + " ile devam et"
      : "Kapat";
    controls.innerHTML =
      '<div class="fms-buttons"><button type="button" class="fms-btn-next" data-fms-continue>' + ctaLabel + "</button></div>";
    controls.querySelector("[data-fms-continue]").addEventListener("click", function () {
      if (variantValue) applyVariantSelection(r.winnerRow);
      closeQuiz();
    });
    controls.querySelector("[data-fms-continue]").focus();
    wrap.querySelector("[data-fms-restart]").addEventListener("click", function () {
      resetState();
      renderStep();
    });
  }

  function openQuiz(trigger) {
    var block = trigger.closest(".fms-block");
    var nextConfig = readConfig(block);
    if (!nextConfig) return;
    var keys = keysForProfile(categoryProfile(nextConfig));
    if (!keys.length) return;
    var changed = block !== activeBlock || JSON.stringify(nextConfig) !== JSON.stringify(config);
    config = nextConfig;
    activeBlock = block;
    measurementKeys = keys;
    steps = STEPS.filter(function (s) { return s.key === "height" || s.key === "weight" || keys.indexOf(s.key) !== -1; });
    if (!overlay) buildOverlay();
    if (changed || !started || completed) { resetState(); started = true; }
    returnFocus = trigger;
    previousOverflow = document.documentElement.style.overflow;
    overlay.classList.add("is-open");
    document.documentElement.style.overflow = "hidden";
    renderStep();
  }

  function closeQuiz() {
    if (!overlay || !overlay.classList.contains("is-open")) return;
    overlay.classList.remove("is-open");
    document.documentElement.style.overflow = previousOverflow;
    if (returnFocus && returnFocus.isConnected) returnFocus.focus();
  }

  /* Tetikleyici: tema section'ları yeniden yüklense bile çalışsın diye delegasyon */
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest ? e.target.closest("[data-fms-open]") : null;
    if (trigger) {
      e.preventDefault();
      openQuiz(trigger);
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Tab" && overlay && overlay.classList.contains("is-open")) {
      var focusable = Array.prototype.filter.call(overlay.querySelectorAll("button, input"), function (el) {
        return !el.disabled && !el.classList.contains("is-hidden");
      });
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && (document.activeElement === first || !overlay.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !overlay.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
    if (e.key === "Escape" && overlay && overlay.classList.contains("is-open")) closeQuiz();
  });
  initBlocks(document);
  document.addEventListener("shopify:section:load", function (e) { initBlocks(e.target); });
})();